import { load, save } from '#sources/AccountLocalStorage';

import { SHOW_EMPTY_REPOSITORIES } from './constants';

export const saveShowEmptyRepositoriesToCache = (showEmpty: boolean) =>
  save(load().set(SHOW_EMPTY_REPOSITORIES, showEmpty));
